import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.SectionFilters', {
    disabledFieldText: 'The filter is disabled because the Organisation has been disconnected from {integrationName}',
    disconnectionWarningText:
        'Some filters cannot be modified since the company is disconnected from {integrationName}',
});
